// frontend/src/features/workflows/utils/auditFormatting.js

export function formatAuditEvent(event) {
  const action = event?.action;
  const type = event?.object_type;
  const payload = event?.payload || {};

  if (type === 'batch') {
    if (action === 'BATCH_CREATED') return 'Batch created';
    if (action === 'BATCH_UPDATED') return 'Batch updated';
    if (action === 'BATCH_FINALIZED' || action === 'BATCH_FINALIZED_WITH_EXCLUSIONS') {
      return 'Batch finalized';
    }
    if (action === 'BATCH_REOPENED') return 'Batch reopened';
    if (action === 'GROUPING_CLUSTER_CONFIRMED') {
      const measurementCount = Array.isArray(payload.measurement_ids)
        ? payload.measurement_ids.length
        : null;
      const sampleLabel =
        payload.sample_id != null ? `sample #${payload.sample_id}` : 'sample';
      const countLabel =
        measurementCount != null
          ? `, ${measurementCount} measurement${measurementCount === 1 ? '' : 's'}`
          : '';
      const statusLabel =
        payload.created === true
          ? 'created'
          : payload.created === false
            ? 'updated'
            : 'confirmed';
      return `Grouping cluster ${statusLabel} (${sampleLabel}${countLabel})`;
    }
  }

  if (type === 'sample') {
    if (action === 'SAMPLE_CREATED') return `Sample created (${payload.sample_type || 'sample'})`;
    if (action === 'SAMPLE_DOCUMENT_UPLOADED') return `Sample document uploaded (${payload.file_type})`;
    if (action === 'SAMPLE_IMPORTED') return `Sample imported (${payload.pipeline || 'upload'})`;
    if (action === 'SAMPLE_UPDATED') return 'Sample updated';
    if (action === 'SAMPLE_DELETED') return 'Sample deleted';
  }

  if (type === 'analysis_run') {
    if (action === 'RUN_CREATED') return `Run created (${payload.pipeline})`;
    if (action === 'RUN_COMPLETED') return `Run completed (${payload.pipeline})`;
    if (action === 'RUN_FAILED') return `Run failed (${payload.pipeline})`;
    if (action === 'RUN_RESTARTED') return `Run restarted (${payload.pipeline})`;
    if (action === 'RUN_INVALIDATED') return `Run invalidated (${payload.pipeline})`;
  }

  if (type === 'batch_analysis' && action === 'BATCH_ANALYSIS_RUN') {
    const pipelineLabel = payload.pipeline === 'encapsulation' ? 'Encapsulation' : 'Size';
    const total = payload.total_runnable_samples ?? payload.selected_count ?? 0;
    const selected = payload.selected_count ?? payload.sample_ids?.length ?? 0;
    const scopeLabel =
      payload.scope === 'all_samples' && total ? 'full batch' : 'partial';
    return `Batch analysis run – ${pipelineLabel} – ${selected} of ${total} samples (${scopeLabel})`;
  }

  const actionLabel = action || 'Event';
  const typeLabel = type || 'object';
  return `${actionLabel} (${typeLabel})`;
}
